module.exports = __webpack_public_path__ + "img/no-goods.8d2b36bc.png";